if (!customElements.get('combo-offer-selector')) {
  customElements.define(
    'combo-offer-selector',
    class ComboOfferSelector extends HTMLElement {
      connectedCallback() {
        this.quantityInput = document.querySelector(this.dataset.quantityInput);
        this.addEventListener('change', this.onTierChange.bind(this));
      }

      onTierChange(event) {
        if (!event.target.matches('.combo-offer__radio') || !this.quantityInput) return;

        const quantity = parseInt(event.target.value, 10);
        if (isNaN(quantity) || quantity < 1) return;

        this.quantityInput.value = quantity;
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  );
}
